/* I Do Holding whitelabel
   Clients must never see the words "ERPNext" or "Frappe" in the UI.
   A one-time sweep + MutationObserver rewrites text nodes, common
   attributes and the document title as the desk renders. Vendor links
   (frappe.io / erpnext.com docs & support) are hidden from menus. */

(function () {
	"use strict";

	var SUPPORT_URL = "https://support.ido.sa";

	var REPLACEMENTS = [
		[/https?:\/\/support\.frappe\.io\S*/g, SUPPORT_URL],
		[/ERPNext|ErpNext|Erpnext|ERPNEXT|erpnext/g, "IDO ERP"],
		[/Frappe Framework/g, "IDO Framework"],
		[/Frappe Cloud/g, "Cloud"],
		[/Frappe|FRAPPE|frappe/g, "IDO"],
	];

	var SKIP_TAGS = {
		SCRIPT: 1,
		STYLE: 1,
		TEXTAREA: 1,
		INPUT: 1,
		SELECT: 1,
		CODE: 1,
		PRE: 1,
	};

	var TEXT_ATTRS = ["title", "placeholder", "alt", "data-original-title", "aria-label"];

	var VENDOR_LINK = /(^|\.)frappe\.io|(^|\.)erpnext\.com|frappeframework\.com|frappecloud\.com/;

	function clean(text) {
		if (!text) return text;
		for (var i = 0; i < REPLACEMENTS.length; i++) {
			text = text.replace(REPLACEMENTS[i][0], REPLACEMENTS[i][1]);
		}
		return text;
	}

	var NEEDS_CLEAN = /erpnext|frappe/i;

	function needsClean(text) {
		return text && NEEDS_CLEAN.test(text);
	}

	function scrub(node) {
		if (node.nodeType === Node.TEXT_NODE) {
			// vendor deprecation notices ("...please use Frappe CRM instead")
			// should disappear entirely, not read awkwardly after scrubbing
			if (/scheduled for deprecation/i.test(node.nodeValue || "")) {
				var block =
					node.parentElement &&
					(node.parentElement.closest(".ce-block, .widget, p") || node.parentElement);
				if (block) block.style.display = "none";
				return;
			}
			if (needsClean(node.nodeValue)) node.nodeValue = clean(node.nodeValue);
			return;
		}
		if (node.nodeType !== Node.ELEMENT_NODE || SKIP_TAGS[node.tagName]) return;

		// vendor links: support links are repointed to the IDO support
		// portal; everything else redirecting to the vendor is hidden
		if (node.tagName === "A") {
			var href = node.href || "";
			if (/support\.frappe\.io|frappe\.io\/support/i.test(href)) {
				node.setAttribute("href", SUPPORT_URL);
				node.setAttribute("target", "_blank");
			} else if (
				VENDOR_LINK.test(node.hostname || "") ||
				/github\.com\/frappe/i.test(href)
			) {
				var item =
					node.closest(".dropdown-menu li, .dropdown-item, .promotional-banner") || node;
				item.style.display = "none";
				return;
			}
		}

		// hide vendor LOGO images (text scrubbing can't reach pixels):
		// e.g. the Frappe wordmark in the About dialog. Match logo file
		// names only — plenty of legitimate icons are served from
		// /assets/erpnext/... and must stay visible.
		if (
			node.tagName === "IMG" &&
			/(frappe|erpnext)[^\/]*logo|logo[^\/]*(frappe|erpnext)/i.test(
				node.getAttribute("src") || ""
			) &&
			node.closest(".modal, .about-dialog")
		) {
			node.style.display = "none";
			return;
		}

		for (var i = 0; i < TEXT_ATTRS.length; i++) {
			var attr = TEXT_ATTRS[i];
			var value = node.getAttribute && node.getAttribute(attr);
			if (needsClean(value)) node.setAttribute(attr, clean(value));
		}

		var child = node.firstChild;
		while (child) {
			var next = child.nextSibling;
			scrub(child);
			child = next;
		}
	}

	function scrubTitle() {
		if (needsClean(document.title)) document.title = clean(document.title);
	}

	function start() {
		if (!document.body) return;
		scrub(document.body);
		scrubTitle();

		var observer = new MutationObserver(function (mutations) {
			for (var i = 0; i < mutations.length; i++) {
				var m = mutations[i];
				if (m.type === "characterData") {
					scrub(m.target);
				} else {
					for (var j = 0; j < m.addedNodes.length; j++) {
						scrub(m.addedNodes[j]);
					}
				}
			}
			scrubTitle();
		});
		observer.observe(document.documentElement, {
			childList: true,
			subtree: true,
			characterData: true,
		});
	}

	// menu items opened via JS (e.g. the desktop user menu's Support
	// entry hardcodes window.open("https://support.frappe.io/help"))
	var native_open = window.open;
	window.open = function (url, name, features) {
		if (typeof url === "string") {
			if (/support\.frappe\.io|frappe\.io\/support/i.test(url)) {
				url = SUPPORT_URL;
			} else if (/frappe\.io|erpnext\.com|frappecloud\.com|frappeframework\.com/i.test(url)) {
				return null; // never open vendor pages
			}
		}
		return native_open.call(window, url, name, features);
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", start);
	} else {
		start();
	}
})();

/* ---- Branded About dialog ----
   Replaces frappe.ui.misc.about entirely: I Do identity + installed
   app versions, no vendor branding. Loaded after the desk bundle, so
   this override wins. */
(function () {
	"use strict";

	if (!window.frappe) return;

	frappe.provide("frappe.ui.misc");

	frappe.ui.misc.about = function () {
		if (frappe.ui.misc.ido_about_dialog) {
			frappe.ui.misc.ido_about_dialog.show();
			return;
		}

		var logo =
			(frappe.boot.navbar_settings && frappe.boot.navbar_settings.app_logo) ||
			"/assets/ido_design/images/ido-mark.png";
		var app_name =
			(frappe.boot.sysdefaults && frappe.boot.sysdefaults.app_name) || "I Do";

		var dialog = new frappe.ui.Dialog({ title: __("About") });
		$(dialog.wrapper).addClass("ido-about-dialog");

		$(dialog.body).html(
			'<div class="ido-about">' +
				'<img class="ido-about-logo" src="' + logo + '" alt="' + app_name + '">' +
				'<div class="ido-about-name">' + app_name + "</div>" +
				'<p class="ido-about-tagline">' +
				__("Integrated business platform by I Do Holding") +
				"</p>" +
				'<div class="ido-about-section-label">' + __("Platform") + "</div>" +
				'<div class="ido-about-rows" id="ido-about-versions">' +
				__("Loading...") +
				"</div>" +
				'<div class="ido-about-footer">&copy; ' +
				new Date().getFullYear() +
				" I Do Holding — " +
				__("All rights reserved") +
				"</div>" +
				"</div>"
		);

		var render_versions = function (versions) {
			var rows = "";
			var order = Object.keys(versions || {}).sort(function (a, b) {
				// platform first, then alphabetical
				if (a === "frappe") return -1;
				if (b === "frappe") return 1;
				return a.localeCompare(b);
			});
			order.forEach(function (key) {
				var app = versions[key];
				if (!app || !app.version) return;
				var label =
					key === "frappe"
						? __("IDO Framework")
						: key === "erpnext"
							? __("IDO ERP Modules")
							: __(app.title || key);
				rows +=
					'<div class="ido-about-row">' +
					'<span class="ido-about-app">' + label + "</span>" +
					'<span class="ido-about-version">v' + app.version + "</span>" +
					"</div>";
			});
			$("#ido-about-versions").html(rows || __("No version information"));
		};

		dialog.on_page_show = function () {
			if (frappe.versions) {
				render_versions(frappe.versions);
				return;
			}
			frappe.call({
				method: "frappe.utils.change_log.get_versions",
				callback: function (r) {
					frappe.versions = r.message;
					render_versions(r.message);
				},
			});
		};

		frappe.ui.misc.ido_about_dialog = dialog;
		dialog.show();
	};
})();

/* ---- Attach / Attach Image: show an inline preview for image files ---- */
(function () {
	"use strict";

	var IMAGE_EXT = /\.(png|jpe?g|gif|webp|bmp|svg|avif|heic|heif)(\?|#|$)/i;

	function preview_src(value, dataurl) {
		if (dataurl) return dataurl;
		if (!value) return "";
		if (/^data:image\//i.test(value)) return value;
		var parts = String(value).match(/^([^:]+),(.+:.+)$/);
		if (parts && /^data:image\//i.test(parts[2])) return parts[2];
		return value;
	}

	function is_image(src) {
		if (!src) return false;
		if (/^data:image\//i.test(src)) return true;
		return IMAGE_EXT.test(String(src).split("?")[0]);
	}

	function patch_attach() {
		var ControlAttach = frappe.ui && frappe.ui.form && frappe.ui.form.ControlAttach;
		if (!ControlAttach || ControlAttach.prototype.__ido_image_preview) return false;

		var orig_make = ControlAttach.prototype.make_input;
		var orig_set = ControlAttach.prototype.set_input;

		ControlAttach.prototype.make_input = function () {
			orig_make.apply(this, arguments);
			this._ido_ensure_preview();
		};

		ControlAttach.prototype.set_input = function (value, dataurl) {
			orig_set.apply(this, arguments);
			this._ido_ensure_preview();
			this._ido_refresh_preview(dataurl);
		};

		ControlAttach.prototype._ido_ensure_preview = function () {
			if (this.$preview || !this.input_area) return;
			this.$preview = $(
				'<div class="ido-attach-preview" hidden>' +
					'<a class="ido-attach-preview-link" target="_blank" rel="noopener noreferrer">' +
					'<img class="ido-attach-preview-img" alt="">' +
					"</a>" +
					"</div>"
			);
			if (this.$value && this.$value.length) {
				this.$preview.insertBefore(this.$value);
			} else {
				$(this.input_area).prepend(this.$preview);
			}
			var me = this;
			this.$preview.find("img").on("error", function () {
				me._ido_hide_preview();
			});
		};

		ControlAttach.prototype._ido_hide_preview = function () {
			if (!this.$preview) return;
			this.$preview.attr("hidden", "hidden");
			this.$preview.find("img").attr("src", "");
		};

		ControlAttach.prototype._ido_refresh_preview = function (dataurl) {
			if (!this.$preview) return;
			var src = preview_src(this.value, dataurl);
			if (!this.value || !is_image(src)) {
				this._ido_hide_preview();
				return;
			}
			this.$preview.find("img").attr({ src: src, alt: this.df ? this.df.label || "" : "" });
			this.$preview.find("a").attr("href", src);
			this.$preview.removeAttr("hidden");
		};

		ControlAttach.prototype.__ido_image_preview = true;
		return true;
	}

	function start() {
		if (patch_attach()) return;
		var tries = 0;
		var timer = setInterval(function () {
			tries += 1;
			if (patch_attach() || tries > 40) clearInterval(timer);
		}, 250);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", start);
	} else {
		start();
	}
})();
/* ---- Form sidebar Attachments: open a slider popup instead of File list ---- */
(function () {
	"use strict";

	var IMAGE_EXT = /\.(png|jpe?g|gif|webp|bmp|svg|avif|heic|heif)(\?|#|$)/i;
	var PDF_EXT = /\.pdf(\?|#|$)/i;
	var VIDEO_EXT = /\.(mp4|webm|ogg|mov)(\?|#|$)/i;
	var AUDIO_EXT = /\.(mp3|wav|ogg|m4a|aac)(\?|#|$)/i;

	function esc(text) {
		return frappe.utils.escape_html(text || "");
	}

	function file_kind(name, url) {
		var src = String(name || url || "").split("?")[0];
		if (IMAGE_EXT.test(src)) return "image";
		if (PDF_EXT.test(src)) return "pdf";
		if (VIDEO_EXT.test(src)) return "video";
		if (AUDIO_EXT.test(src)) return "audio";
		return "file";
	}

	function kind_label(kind) {
		return (
			{
				image: __("Image"),
				pdf: __("PDF"),
				video: __("Video"),
				audio: __("Audio"),
				file: __("File"),
			}[kind] || __("File")
		);
	}

	function ext_label(name, url) {
		var src = String(name || url || "").split("?")[0];
		var parts = src.split(".");
		if (parts.length < 2) return "FILE";
		return parts.pop().toUpperCase().slice(0, 4);
	}

	function unique_attachments(list) {
		var seen = {};
		return (list || []).filter(function (att) {
			var key = att.name || att.file_url || att.file_name;
			if (!key || seen[key]) return false;
			seen[key] = true;
			return true;
		});
	}

	function get_attachments_api() {
		if (cur_frm && cur_frm.attachments) return cur_frm.attachments;
		return null;
	}

	function build_slide_html(att, url, kind) {
		var name = att.file_name || url;
		if (kind === "image") {
			return (
				'<img class="ido-att-gallery-img" src="' +
				esc(url) +
				'" alt="' +
				esc(name) +
				'">'
			);
		}
		if (kind === "pdf") {
			return (
				'<iframe class="ido-att-gallery-frame" src="' +
				esc(url) +
				'" title="' +
				esc(name) +
				'"></iframe>'
			);
		}
		if (kind === "video") {
			return (
				'<video class="ido-att-gallery-media" controls playsinline src="' +
				esc(url) +
				'"></video>'
			);
		}
		if (kind === "audio") {
			return (
				'<div class="ido-att-gallery-fallback">' +
				'<div class="ido-att-gallery-icon-wrap">' +
				frappe.utils.icon("play", "lg") +
				"</div>" +
				'<div class="ido-att-gallery-fallback-title">' +
				esc(name) +
				"</div>" +
				'<audio class="ido-att-gallery-audio" controls src="' +
				esc(url) +
				'"></audio>' +
				"</div>"
			);
		}
		return (
			'<div class="ido-att-gallery-fallback">' +
			'<div class="ido-att-gallery-icon-wrap">' +
			frappe.utils.icon("file", "lg") +
			"</div>" +
			'<div class="ido-att-gallery-fallback-title">' +
			esc(name) +
			"</div>" +
			'<div class="ido-att-gallery-fallback-sub">' +
			__("Preview not available for this file type") +
			"</div>" +
			'<a class="btn btn-primary btn-sm" href="' +
			esc(url) +
			'" target="_blank" rel="noopener noreferrer">' +
			__("Open File") +
			"</a>" +
			"</div>"
		);
	}

	function open_attachment_gallery(attachments_api, start_fileid) {
		attachments_api = attachments_api || get_attachments_api();
		if (!attachments_api) return;

		var attachments = unique_attachments(attachments_api.get_attachments());
		if (!attachments.length) {
			frappe.show_alert({ message: __("No attachments"), indicator: "orange" });
			return;
		}

		var index = 0;
		if (start_fileid) {
			var found = attachments.findIndex(function (a) {
				return a.name === start_fileid;
			});
			if (found >= 0) index = found;
		}

		var dialog = new frappe.ui.Dialog({
			title: __("Attachments"),
			size: "extra-large",
			fields: [{ fieldtype: "HTML", fieldname: "gallery" }],
		});

		dialog.$wrapper.addClass("ido-att-gallery-dialog");
		dialog.set_title(
			'<span class="ido-att-dialog-title">' +
				frappe.utils.icon("paperclip", "sm") +
				"<span>" +
				__("Attachments") +
				"</span></span>"
		);

		var $body = $(dialog.fields_dict.gallery.$wrapper);
		$body.html(
			'<div class="ido-att-gallery">' +
				'<div class="ido-att-gallery-top">' +
				'<div class="ido-att-gallery-meta">' +
				'<div class="ido-att-gallery-title ellipsis"></div>' +
				'<div class="ido-att-gallery-sub">' +
				'<span class="ido-att-kind"></span>' +
				'<span class="ido-att-privacy"></span>' +
				'<span class="ido-att-gallery-counter"></span>' +
				"</div>" +
				"</div>" +
				'<div class="ido-att-gallery-actions">' +
				'<a class="btn btn-default btn-sm ido-att-open" target="_blank" rel="noopener noreferrer">' +
				frappe.utils.icon("external-link", "xs") +
				"<span>" +
				__("Open") +
				"</span></a>" +
				'<a class="btn btn-primary btn-sm ido-att-download" download>' +
				frappe.utils.icon("download", "xs") +
				"<span>" +
				__("Download") +
				"</span></a>" +
				"</div>" +
				"</div>" +
				'<div class="ido-att-gallery-stage-wrap">' +
				'<button type="button" class="btn ido-att-nav ido-att-prev" title="' +
				__("Previous") +
				'" aria-label="' +
				__("Previous") +
				'">' +
				frappe.utils.icon("chevron-left", "md") +
				"</button>" +
				'<div class="ido-att-gallery-stage"></div>' +
				'<button type="button" class="btn ido-att-nav ido-att-next" title="' +
				__("Next") +
				'" aria-label="' +
				__("Next") +
				'">' +
				frappe.utils.icon("chevron-right", "md") +
				"</button>" +
				"</div>" +
				'<div class="ido-att-gallery-thumbs" role="listbox" aria-label="' +
				__("Attachments") +
				'"></div>' +
				"</div>"
		);

		var $stage = $body.find(".ido-att-gallery-stage");
		var $title = $body.find(".ido-att-gallery-title");
		var $kind = $body.find(".ido-att-kind");
		var $privacy = $body.find(".ido-att-privacy");
		var $counter = $body.find(".ido-att-gallery-counter");
		var $thumbs = $body.find(".ido-att-gallery-thumbs");
		var $open = $body.find(".ido-att-open");
		var $download = $body.find(".ido-att-download");
		var $prev = $body.find(".ido-att-prev");
		var $next = $body.find(".ido-att-next");

		attachments.forEach(function (att, i) {
			var url = attachments_api.get_file_url(att);
			var kind = file_kind(att.file_name, url);
			var $thumb = $(
				'<button type="button" class="ido-att-thumb" data-index="' +
					i +
					'" role="option" title="' +
					esc(att.file_name || url) +
					'"></button>'
			);
			if (kind === "image") {
				$thumb.append(
					$("<img>").attr({
						src: url,
						alt: att.file_name || "",
						loading: "lazy",
					})
				);
			} else {
				$thumb.append(
					$('<span class="ido-att-thumb-label"></span>').text(ext_label(att.file_name, url))
				);
			}
			$thumbs.append($thumb);
		});

		function render() {
			var att = attachments[index];
			var url = attachments_api.get_file_url(att);
			var kind = file_kind(att.file_name, url);
			var name = att.file_name || url;
			var is_private = cint(att.is_private);

			$title.attr("title", name).text(name);
			$kind.text(kind_label(kind));
			$privacy
				.toggleClass("is-private", !!is_private)
				.toggleClass("is-public", !is_private)
				.text(is_private ? __("Private") : __("Public"));
			$counter.text(index + 1 + " / " + attachments.length);
			$open.attr("href", url);
			$download.attr({ href: url, download: name });

			$stage
				.removeClass("is-image is-pdf is-video is-audio is-file")
				.addClass("is-" + kind)
				.html(build_slide_html(att, url, kind));

			$thumbs.find(".ido-att-thumb").removeClass("active").attr("aria-selected", "false");
			var $active = $thumbs.find('.ido-att-thumb[data-index="' + index + '"]');
			$active.addClass("active").attr("aria-selected", "true");
			if ($active.length && $active[0].scrollIntoView) {
				$active[0].scrollIntoView({
					behavior: "smooth",
					inline: "center",
					block: "nearest",
				});
			}

			var multi = attachments.length > 1;
			$prev.toggleClass("hidden", !multi);
			$next.toggleClass("hidden", !multi);
			$thumbs.toggleClass("hidden", !multi);
		}

		function go(delta) {
			index = (index + delta + attachments.length) % attachments.length;
			render();
		}

		$prev.on("click", function (e) {
			e.preventDefault();
			go(-1);
		});
		$next.on("click", function (e) {
			e.preventDefault();
			go(1);
		});
		$thumbs.on("click", ".ido-att-thumb", function () {
			index = cint($(this).attr("data-index"));
			render();
		});

		function on_keydown(e) {
			if (!dialog.display) return;
			if (e.key === "ArrowLeft") {
				e.preventDefault();
				go(-1);
			} else if (e.key === "ArrowRight") {
				e.preventDefault();
				go(1);
			}
		}

		$(document).on("keydown.ido_att_gallery", on_keydown);
		dialog.$wrapper.on("hidden.bs.modal", function () {
			$(document).off("keydown.ido_att_gallery");
		});

		render();
		dialog.show();
	}

	function wire_row($row, attachments_api, fileid) {
		if (!$row || !$row.length) return;
		$row.attr("data-ido-file-id", fileid);
		$row.find("a.attachment-file-label, a.attachment-icon").each(function () {
			var $a = $(this);
			$a.attr({ href: "#", "data-ido-file-id": fileid });
			$a.removeAttr("target");
		});
	}

	function patch_attachments() {
		var Attachments = frappe.ui && frappe.ui.form && frappe.ui.form.Attachments;
		if (!Attachments || Attachments.prototype.__ido_att_gallery) return false;

		var orig_make = Attachments.prototype.make;
		var orig_add = Attachments.prototype.add_attachment;

		Attachments.prototype.make = function () {
			orig_make.apply(this, arguments);
			var me = this;
			// Replace explore-link handler so it never routes to File list
			this.parent
				.find(".explore-link")
				.off("click")
				.on("click.ido_att_gallery", function (e) {
					e.preventDefault();
					e.stopImmediatePropagation();
					var list = me.get_attachments() || [];
					if (!list.length) return false;
					open_attachment_gallery(me);
					return false;
				});
		};

		Attachments.prototype.add_attachment = function (attachment) {
			orig_add.apply(this, arguments);
			var fileid = attachment.name;
			var $row = this.parent
				.find('.attachment-icon[href="/desk/file/' + fileid + '"]')
				.closest(".attachment-row");
			if (!$row.length) {
				$row = this.parent.find(".attachment-row").first();
			}
			wire_row($row, this, fileid);
		};

		Attachments.prototype.__ido_att_gallery = true;
		return true;
	}

	function bind_global_clicks() {
		if (window.__ido_att_gallery_clicks) return;
		window.__ido_att_gallery_clicks = true;

		// Capture phase so we beat the default File-list / new-tab navigation
		document.addEventListener(
			"click",
			function (e) {
				var target = e.target;
				if (!target || !target.closest) return;

				var explore = target.closest(".form-attachments .explore-link");
				if (explore) {
					var api = get_attachments_api();
					if (!api) return;
					var list = api.get_attachments() || [];
					if (!list.length) return;
					e.preventDefault();
					e.stopPropagation();
					open_attachment_gallery(api);
					return;
				}

				var remove = target.closest(".form-attachments .remove-btn");
				if (remove) return;

				var hit = target.closest(
					".form-attachments .attachment-row, .form-attachments a.attachment-file-label, .form-attachments a.attachment-icon"
				);
				if (!hit) return;

				var row = hit.closest(".attachment-row") || hit;
				var fileid =
					(row.getAttribute && row.getAttribute("data-ido-file-id")) ||
					(hit.getAttribute && hit.getAttribute("data-ido-file-id"));

				if (!fileid) {
					var icon = row.querySelector && row.querySelector(".attachment-icon");
					var href = icon && icon.getAttribute("href");
					var match = href && href.match(/\/file\/([^\/?#]+)/);
					if (match) fileid = match[1];
				}

				var attachments_api = get_attachments_api();
				if (!attachments_api) return;

				e.preventDefault();
				e.stopPropagation();
				open_attachment_gallery(attachments_api, fileid);
			},
			true
		);
	}

	function start() {
		bind_global_clicks();
		if (patch_attachments()) return;
		var tries = 0;
		var timer = setInterval(function () {
			tries += 1;
			if (patch_attachments() || tries > 40) clearInterval(timer);
		}, 250);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", start);
	} else {
		start();
	}
})();

/* ---- ClefinCode Chat: I-DO skin ----
   Chat CSS from that app loads after this bundle (apps.txt order).
   Inject the override stylesheet last so token-based rules win. */
(function () {
	"use strict";

	var HREF = "/assets/ido_design/css/chat.css?v=icon-1";

	function inject() {
		var existing = document.querySelector('link[data-ido-chat-theme]');
		if (existing) {
			if (existing.getAttribute("href") !== HREF) existing.setAttribute("href", HREF);
			return;
		}
		var link = document.createElement("link");
		link.rel = "stylesheet";
		link.href = HREF;
		link.setAttribute("data-ido-chat-theme", "1");
		(document.head || document.documentElement).appendChild(link);
	}

	function restyleLauncher() {
		var wrap = document.getElementById("chat-bubble");
		if (!wrap) return;
		wrap.setAttribute("title", "الشات");
		wrap.setAttribute("aria-label", "فتح الشات");
		wrap.setAttribute("role", "button");
	}

	function mark() {
		var roots = document.querySelectorAll(".chat-app, .chat-window, .chat-element");
		for (var i = 0; i < roots.length; i++) {
			roots[i].classList.add("ido-chat");
		}
		if (document.body) {
			document.body.classList.toggle(
				"ido-thread-open",
				!!document.querySelector(".chat-window")
			);
		}
		restyleLauncher();
	}

	function syncActiveRoom() {
		var open = document.querySelector(".chat-window[data-room]:not([style*='display: none'])")
			|| document.querySelector("body.cc-chat-webview .chat-window[data-room]");
		var room = open && open.getAttribute("data-room");
		var rows = document.querySelectorAll(".chat-room[data-room]");
		for (var i = 0; i < rows.length; i++) {
			rows[i].classList.toggle("ido-room-active", !!room && rows[i].getAttribute("data-room") === room);
		}
	}

	inject();
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", function () {
			inject();
			mark();
			syncActiveRoom();
		});
	} else {
		mark();
		syncActiveRoom();
	}

	if (typeof MutationObserver === "undefined") return;
	var scheduled = false;
	var observer = new MutationObserver(function () {
		if (scheduled) return;
		scheduled = true;
		requestAnimationFrame(function () {
			scheduled = false;
			inject();
			mark();
			syncActiveRoom();
		});
	});
	observer.observe(document.documentElement, { childList: true, subtree: true });
})();

